<app-wizard-bar-nav [frmDisabled]="disabled" [stepIsDirty]="this.isQuoteRequestInvalidated()"> </app-wizard-bar-nav>

<div class="step-container main-content">
  <h2 *ngIf="originalQuoteRequestId">Renewing Quote {{ originalQuoteRequestId }}</h2>

  <h3>Customer Details | <em heading-info [quoteInfo]="quoteRequestState"></em></h3>

  <form [formGroup]="frmQuoteConfiguration">
    <h4 *ngIf="!this.userIdentity?.isBroker">Quote on Behalf of a Brokerage</h4>
    <section class="field-group" *ngIf="!this.userIdentity.isBroker">
      <div class="field-holder w2">
        <mat-form-field appearance="standard">
          <mat-label>Brokerage</mat-label>
          <input id="brokerageName" matInput type="text" formControlName="brokerage" />
          <mat-error *ngIf="frmQuoteConfiguration.get('brokerage').errors?.maxlength"> Maximum length is 255 characters </mat-error>
        </mat-form-field>
      </div>

      <div class="field-holder w2">
        <mat-form-field appearance="standard">
          <mat-label>Broker</mat-label>
          <input id="brokerName" matInput type="text" formControlName="broker" />
          <mat-error *ngIf="frmQuoteConfiguration.get('broker').errors?.maxlength"> Maximum length is 255 characters </mat-error>
        </mat-form-field>
      </div>
    </section>

    <app-customer-details
      formControlName="customerDetails"
      [customerDetails]="quoteData"
      [showValidation]="showValidation"
      [dunsLookupEnabled]="dunsEnabled"
      (organisationNameChange)="orgNameChanged($event)"
      (propagateAddressFound)="storeUtilityInformation($event)"
    ></app-customer-details>

    <h4>Supply Details</h4>

    <div class="field-holder w2" style="margin-bottom: 10px">
      <mat-radio-group
        aria-label="Select an option"
        name="commodityType"
        formControlName="commodityType"
        (change)="this.commodityChanged($event)"
      >
        <mat-radio-button
          value="Electricity"
          style="margin-right: 10px"
          [disabled]="!this.isElectricEnabled"
          [checked]="this.isElectricEnabled"
        >
          <img
            alt="electricity"
            [src]="'/assets/icons/icon-electricity.svg'"
            style="height: 20px; padding-top: 5px; padding-right: 10px"
          />Electricity
        </mat-radio-button>
        <mat-radio-button value="Gas" [disabled]="!this.isGasEnabled" [checked]="!this.isElectricEnabled">
          <img alt="gas" [src]="'/assets/icons/icon-gas.svg'" style="height: 20px; padding-top: 5px; padding-right: 10px" />Gas
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <app-utility-details-presentation
      formControlName="utilityDetails"
      quoteRequestType="Matrix"
      [zones]="zones"
      [iso]="this.iso"
      [showValidation]="showValidation"
      [weatherZones]="this.weatherZones"
      (utilitySelected)="utilitySelected($event)"
      (utilityUomSelected)="utilityUomSelected($event)"
      (utilityDetailsChanged)="utilityDetailsChanged($event)"
      [showControls]="{
        loadingUtilities: this.loadingUtilities,
        emitEventOnValueChange: this.emitEventOnValueChange
      }"
    >
    </app-utility-details-presentation>

    <div class="field-holder w2" *ngIf="pricingSource === PricingSourceEnum.SupplierMatrix">
      <mat-form-field appearance="standard">
        <mat-label>Annual Usage ({{ this.uom }})</mat-label>
        <input id="annualUsage" matInput type="text" formControlName="annualUsage" />
        <mat-error *ngIf="frmQuoteConfiguration.get('annualUsage')?.errors?.required">Value is required</mat-error>
        <mat-error *ngIf="annualUsageIsLessThanZero()">Value must be greater than 0</mat-error>
        <mat-error *ngIf="frmQuoteConfiguration.get('annualUsage')?.errors?.pattern">
          Value must be a number with 2 decimal places or fewer
        </mat-error>
      </mat-form-field>
    </div>

    <h4>Contract Details</h4>
    <mat-radio-group formControlName="saleType" aria-label="Select an option">
      <mat-radio-button value="Acquisition" style="margin-right: 10px">Acquisition</mat-radio-button>
      <mat-radio-button checked value="Renewal">Renewal</mat-radio-button>
    </mat-radio-group>

    <section class="field-group" *ngIf="(this.commodityType$ | async) === commodityTypeEnum.Electricity">
      <div class="field-holder w2">
        <mat-form-field appearance="standard" hideRequiredMarker="true">
          <mat-label>Product Type</mat-label>
          <mat-select formControlName="productType" required (selectionChange)="productSelectionChanged($event?.value)">
            <mat-option value="">-- Please Select --</mat-option>
            <mat-option
              *ngFor="let productType of (productTypes$ | async).length < 1 ? [{ productType: 'Fixed' }] : (productTypes$ | async)"
              [value]="productType.productType"
            >
              {{ productType.productType }}
            </mat-option>
          </mat-select>
          <mat-error> Please select a Product Type. </mat-error>
        </mat-form-field>
      </div>
    </section>

    <section class="field-group">
      <div class="field-holder contract-lengths">
        <label>Contract Length (months)</label>
        <app-contract-lengths
          formControlName="contractLengths"
          [FilterMode]="false"
          [showAllButton]="true"
          [showPlusButton]="isDynamic$ | async"
          [readonly]="isReadonly()"
          (notifyAllChanged)="allContractLengthsSelected($event)"
          [contractLenghtsToShow]="defaultContractLengthButtonsToShow"
        >
        </app-contract-lengths>
        <!-- <mat-error *ngIf="contractLengths?.value.length < 1 && (contractLengths.dirty || contractLengths.touched)">
        Please select at least one Contract Length
      </mat-error> -->
        <!-- <mat-error *ngIf="contactLengthClickEvent?.maxReached"> You can select up to 5 Contract Lengths </mat-error> -->
      </div>
    </section>

    <section>
      <br />
      <mat-checkbox id="sweetSpotCheckbox" color="primary" formControlName="sweetSpotCheckbox" (change)="sweetSpotCheckboxChanged($event)">
        <span id="checkboxText">Include Sweet Spot for the full range</span>
      </mat-checkbox>
    </section>

    <app-billing-input [quoteRequestId]="quoteRequestId"> </app-billing-input>
  </form>
</div>

<app-wizard-step-nav-buttons [hideBack]="true" (nextClicked)="next()"></app-wizard-step-nav-buttons>
